import React from 'react';
import style from "./Nav.module.css";
import {NavLink} from 'react-router-dom';


const Nav = () => {
    return (
        <div className={style.navBar}>
            <nav className={style.iconContainer} >
                <NavLink className={style.icon} to="/react/profile" alt="Home">
                    <i className="fa-solid fa-house"></i>
                </NavLink>
                <NavLink className={style.icon} to="/react/newsfeed" alt="Newsfeed">
                    <i class="fa-solid fa-bars"></i>
                </NavLink>
                <NavLink className={style.icon} to="/react/friends" alt="Friends">
                    <i className="fa-regular fa-user"></i>
                </NavLink>
                <NavLink className={style.icon} to="/react/dialogs/user1" alt="Messages">
                    <i className="fa-regular fa-comment-dots"></i>
                </NavLink>
                <NavLink className={style.icon} to="/react/photos" alt="Photos">
                    <i className="fa-regular fa-image"></i>
                </NavLink>
                <NavLink className={style.icon} to="/react/videos" alt="Videos">
                    <i className="fa-brands fa-youtube"></i>
                </NavLink>
            </nav>


            {/*<nav className={style.friendsContainer} >*/}
            {/*    <ul className={style.friendsSideBar}>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*        <li className={style.friendSideBarItem}>*/}
            {/*            <a className={style.navLink} href="#">*/}
            {/*                <img className={style.friendAvatar} src="" alt=""/>*/}
            {/*            </a>*/}
            {/*        </li>*/}
            {/*    </ul>*/}



            {/*</nav>*/}
        </div>


    );
};

export default Nav;